import Vue from 'vue'
import store from '@/store/store';

let activeRequests = 0;
let navigationInProgress = false;
// Axios configs for async requests to the API

axios.authURL = (process.env.API_AUTH_SERVER !== undefined) 
    ? process.env.API_AUTH_SERVER : 'http://qa-api-resourceserver-pluralo.azurewebsites.net/api/';

axios.defaults.baseURL = (process.env.API_RESOURCES_SERVER !== undefined) 
    ? process.env.API_RESOURCES_SERVER : 'http://qa-api-resourceserver-pluralo.azurewebsites.net/';

axios.defaults.headers.common['Authorization'] = localStorage.getItem('pluralo_token') 
    ? `Bearer ${localStorage.getItem('pluralo_token')}` : null;

axios.interceptors.request.use(function (response) {
    let token = localStorage.getItem('pluralo_token');

    // Starts the progress bar only if there are no active requests
    if (activeRequests === 0) {
        Vue.prototype.$Progress.start();
    }

    // Increment the active request counter
    activeRequests += 1;
    response.headers['Authorization'] = token ? `Bearer ${token}` : null;

    return response;
}, function (error) {
    activeRequests = Math.max(activeRequests - 1, 0);

    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // Decrement the active request counter after a response
    activeRequests = Math.max(activeRequests - 1, 0);

    if (response.data === null) {
        return null
    }
    
    // This is used for when the server needs to send data with the response, this can be for example a warning on a successful response
    if (response && response.data.serverInfo) {
        if(response.data.serverInfo.isToShowServerInfo && response.data.serverInfo.isToShowServerInfo == true) {
            store.dispatch('richPrompt', response.data.serverInfo).then(response => {
                console.log(response);
            }).catch(err => {
                console.log(err);
            })
        }

        response.serverInfo = response.data.serverInfo;
        response.data = response.data.serverResponse;
    }

    // Wait for the Vue rendering cycle to complete before finalizing the progress bar
    if (activeRequests === 0) {
        Vue.nextTick(() => {
            setTimeout(() => {
                // Ends after the rendering cycle
                Vue.prototype.$Progress.finish(); 
            // Additional delay for smoothness
            }, 200);
        });
    }

    return response;
}, function (error) {
    // Decrement the active request counter after a response
    activeRequests = Math.max(activeRequests - 1, 0);

    // This is used for when the server needs to send data with the response, this can be for example a warning on a successful response
    if (error.response && error.response.data.serverInfo) {
        if (error.response.data.serverInfo.isToShowServerInfo && error.response.data.serverInfo.isToShowServerInfo == true) {
            store.dispatch('richPrompt', error.response.data.serverInfo).then(response => {
                console.log(response);
            }).catch(err => {
                console.log(err);
            })
        }

        error.response.serverInfo = error.response.data.serverInfo;
        error.response.data = error.response.data.serverResponse;
    }

    if (error.response && error.response.status === 400) {
        if (error.response.data !== undefined && error.response.data && error.response.data.message !== undefined && error.response.data.message) {
            if (error.response.data.messageDetails) {
                const { message } = error.response.data;
                let errorMessageDetails = `<div>${message}</div>`;
                
                for (let messageDetail of error.response.data.messageDetails) {
                    errorMessageDetails = `<div>${messageDetail}</div>`;
                }

                Vue.toasted.error(errorMessageDetails);
            } else {
                Vue.toasted.error(error.response.data.message);
            }
        }
    } else if (error.response && error.response.status === 401) {
        store.dispatch('handleLogout');
    } else if (error.response && error.response.status === 404) {
        return;
    }

    // Wait for the Vue rendering cycle to complete before finalizing the progress bar
    if (activeRequests === 0) {
        Vue.nextTick(() => {
            setTimeout(() => {
                Vue.prototype.$Progress.fail();
            }, 200);
        });
    }

    return Promise.reject(error);
});

// Protect guarded routes or move forward if possible.
// All routes are bound to the progress bar automatically
Vue.router.beforeEach((to, from, next) => {
    let loginPath = 'auth.login';
    let token = localStorage.getItem('pluralo_token');

    // Start the progress bar for navigation only if it is not in progress
    if (!navigationInProgress && activeRequests === 0) {
        Vue.prototype.$Progress.start();
        navigationInProgress = true;
    }

    // Set a custom title if any
    if (to.meta.title !== undefined) {
        document.title = to.meta.title;
    }

    // Trying to access a protected route? Redirect to login page
    if (to.matched.some(record => record.meta.protected) && !token) {
        next({ name: loginPath, query: { redirect: to.name }});
    }
    
    // Trying to access the login page while logged in? Go back
    else if (to.matched.some(record => record.name === loginPath) && token) {
        next({ path: from.path });
    }
    else {
        next();
    }
});

Vue.router.afterEach((to, from) => {
    // Ensure that the navigation progress bar is only finalized after Axios requests have been completed when there is route changes
    Vue.nextTick(() => {
        // Ensure there are no active requests
        if (activeRequests === 0) {
            setTimeout(() => {
                // Finish smoothly after requests
                Vue.prototype.$Progress.finish();
                navigationInProgress = false;
            // Delay of 200ms for smoothing
            }, 200);
        }
    });
});



// WEBPACK FOOTER //
// ./src/transport.js